import React from 'react';

import {SwipeDirection, swipeLeft, swipeRight} from '../../../types';

export const useCarouselSwipe = (
    handleSwipeSuccess: (options: {swipeDirection: SwipeDirection}) => void
) => {
    const carouselTouchStartXRef = React.useRef(0);
    const carouselTouchStartYRef = React.useRef(0);

    const handleCarouselTouchStart = React.useCallback((event: TouchEvent) => {
        const {clientX, clientY} = event.touches[0];
        carouselTouchStartXRef.current = clientX;
        carouselTouchStartYRef.current = clientY;
    }, []);

    const handleCarouselTouchEnd = React.useCallback(
        (event: TouchEvent) => {
            const {clientX, clientY} = event.changedTouches[0];
            const deltaX = clientX - carouselTouchStartXRef.current;
            const deltaY = clientY - carouselTouchStartYRef.current;
            const SWIPE_THRESHOLD = 40;

            let swipeDirection: SwipeDirection;
            if (
                Math.abs(deltaX) > Math.abs(deltaY) &&
                Math.abs(deltaX) > SWIPE_THRESHOLD
            ) {
                swipeDirection = deltaX > 0 ? swipeRight : swipeLeft;
            } else {
                swipeDirection = null;
            }

            handleSwipeSuccess({swipeDirection});
        },
        [handleSwipeSuccess]
    );

    return {
        carouselTouchStartXRef,
        carouselTouchStartYRef,
        handleCarouselTouchStart,
        handleCarouselTouchEnd
    };
};
